/**
 * I am a simple object used to store selection with additional information.
 *
 * I am composed of:
 * - entry:            an `entry'
 * - widget:            its corresponding `entryWidget'
 * - isShiftSelection:    a boolean used to know if the item has been added
 * to the selection during a -shift- action.
 */

/**
 * TODO: write documentation
 */
export default class SelectionItem {
	constructor({ entry, widget, isShiftSelection = false }) {
		this._entry = entry;
		this._widget = widget;
		this._isShiftSelection = isShiftSelection;

		// Since the selection item has a pointer to the widget currently shown,
		// the selected entry widget needs to be updated when rebuilt.
		entry.onWidgetBuilt.register((newWidget) => {
			this.setWidget(newWidget);
		});
	}

	entry() {
		return this._entry;
	}

	widget() {
		return this._widget;
	}

	position() {
		return this._widget.position();
	}

	isShiftSelection() {
		return this._isShiftSelection;
	}

	setShiftSelection(bool) {
		this._isShiftSelection = bool;
	}

	setWidget(newWidget) {
		this._widget = newWidget;
	}

	setSelected() {
		this._widget.setSelected();
	}

	unsetSelected() {
		this._isShiftSelection = false;
		this._widget.unsetSelected();
	}
}
